//- ==================================================
//- JavaScript: Widget
//- ==================================================

(function () {

  'use strict';

  var mainClass = 'page-register__gallery';

  fullscreen(mainClass);
  fastScroll(mainClass);

  $('.force--allowselect').attr('style', 'user-select:auto!important')

})();
